var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBubbleOkBtn = function SvgBubbleOkBtn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 57,
    viewBox: "0 0 82 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_143_8976)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 42,
    height: 21,
    rx: 10.5,
    fill: "#D96961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.052 33.096C36.204 33.096 35.44 32.912 34.76 32.544C34.08 32.168 33.544 31.652 33.152 30.996C32.768 30.34 32.576 29.608 32.576 28.8C32.576 27.992 32.768 27.26 33.152 26.604C33.544 25.948 34.08 25.436 34.76 25.068C35.44 24.692 36.204 24.504 37.052 24.504C37.892 24.504 38.652 24.692 39.332 25.068C40.012 25.436 40.544 25.948 40.928 26.604C41.312 27.252 41.504 27.984 41.504 28.8C41.504 29.616 41.312 30.352 40.928 31.008C40.544 31.656 40.012 32.168 39.332 32.544C38.652 32.912 37.892 33.096 37.052 33.096ZM37.052 32.028C37.668 32.028 38.22 31.888 38.708 31.608C39.204 31.328 39.592 30.944 39.872 30.456C40.16 29.96 40.304 29.408 40.304 28.8C40.304 28.192 40.16 27.644 39.872 27.156C39.592 26.66 39.204 26.272 38.708 25.992C38.22 25.712 37.668 25.572 37.052 25.572C36.436 25.572 35.876 25.712 35.372 25.992C34.876 26.272 34.484 26.66 34.196 27.156C33.916 27.644 33.776 28.192 33.776 28.8C33.776 29.408 33.916 29.96 34.196 30.456C34.484 30.944 34.876 31.328 35.372 31.608C35.876 31.888 36.436 32.028 37.052 32.028ZM45.6421 30.036L44.3221 31.26V33H43.1701V24.096H44.3221V29.808L47.7901 26.64H49.1821L46.5061 29.268L49.4461 33H48.0301L45.6421 30.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 18.5,
    width: 41,
    height: 20,
    rx: 10,
    stroke: "white",
    strokeOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_143_8976",
    x: 0,
    y: 0,
    width: 82,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.784797 0 0 0 0 0.784797 0 0 0 0 0.784797 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_143_8976"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_143_8976",
    result: "effect2_dropShadow_143_8976"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_143_8976",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBubbleOkBtn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/bubble-ok-btn.9a61fb8d29c746d4224be0e9a59a7c21.blank.svg";